import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sectionTitle: {
    id: 'lQZ9lb',
    defaultMessage: 'Billing Address',
    description: 'Section title on the Edit Billing Address sub-view',
  },
});
